import React from 'react';
import { List } from '@mui/material';
export default function ListWrapper(_a) {
    var children = _a.children;
    return (React.createElement(List, { dense: true }, children));
}
